'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { useTheme as se } from "../Provider/index.js";
import r from "../../external/classnames/index.js";
import ie from "../AdvancedAccordion/index.js";
import { useState as a, useMemo as oe, useEffect as G, useCallback as ne } from "react";
import c from "../Form/InputBox.js";
import { FontAwesomeIcon as le } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faFire as ce } from "../../external/@fortawesome/pro-light-svg-icons/index.js";
import { calculateCalorieTarget as de, calculateBMR as ue } from "../../helpers/weightUtils.js";
import { useDebounce as j } from "../../hooks/useDebounce.js";
import "../../external/js-cookie/dist/js.cookie.js";
const we = () => {
  const { isMosh: s, isMoshy: i } = se(), [v, W] = a(""), [S, F] = a(""), [p, L] = a(""), [Y, $] = a(""), [y, B] = a(""), [_, R] = a(""), [d, U] = a(""), [u, P] = a(""), [x, X] = a(""), [w, D] = a(null), [M, q] = a(null), [k, z] = a(null), [C, K] = a(null), [E, V] = a(null), g = j(v, 1e3), n = j(p, 1e3), m = j(y, 1e3), J = 18, O = 100, Q = 100, Z = 250, ee = 30, te = 300, T = "Kg", A = "cm", H = "years old", ae = oe(
    () => [
      {
        title: "How is this calculated?",
        content: "Your calorie target is calculated by considering your age, gender, weight, height, and activity level. These factors help estimate your Basal Metabolic Rate (BMR) — the number of calories your body burns at rest — and adjust it based on your daily physical activity. This provides the total calories you need each day to maintain, lose, or gain weight."
      }
    ],
    []
  ), N = (t, l, h, o, f) => {
    const b = Number(t);
    return t ? isNaN(b) ? `Invalid ${o}` : b < l ? `${o.charAt(0).toUpperCase() + o.slice(1)} must be at least ${l} ${f}` : b > h ? `${o.charAt(0).toUpperCase() + o.slice(1)} cannot exceed ${h} ${f}` : "" : "";
  };
  G(() => {
    R(
      N(m, J, O, "age", H)
    ), F(
      N(
        g,
        Q,
        Z,
        "height",
        A
      )
    ), $(
      N(
        n,
        ee,
        te,
        "weight",
        T
      )
    );
  }, [m, g, n]);
  const I = ne(() => {
    if (!m || !g || !n || !d || !u || !x)
      return;
    const t = ue(
      Number(n),
      Number(g),
      Number(m),
      d === "Male" ? "M" : "F"
    ), l = de(
      t,
      u.toLowerCase(),
      "moderate",
      x.toLowerCase()
    ), h = Math.round(Number(n) * 1.5), o = Math.round(l * 0.25), f = Math.round(o / 9), b = l - h * 4 - o, re = Math.round(b / 4);
    V(t), D(l), q(h), z(f), K(re);
  }, [
    m,
    g,
    n,
    d,
    u,
    x
  ]);
  return G(() => {
    I();
  }, [p, v, y, d, u, x, I]), /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ e.jsx(
      "h2",
      {
        className: r("text-center", {
          "text-green-dark": s,
          "text-black": i
        }),
        children: "Calculate your Calories"
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "space-y-4", children: [
      /* @__PURE__ */ e.jsx("p", { className: r("text-center text-grey-400 pb-4"), children: "Estimate your daily calorie requirements to sustain your current weight using the calorie calculator." }),
      /* @__PURE__ */ e.jsxs("div", { className: "max-w-[500px] mx-auto space-y-4", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "bg-grey-100 rounded-2xl p-4 space-y-4 mb-6", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col md:grid md:grid-cols-2 gap-4", children: [
            /* @__PURE__ */ e.jsx(
              c,
              {
                heading: "Your Age",
                unit: H,
                variant: "number",
                value: y,
                onChange: (t) => B(t),
                className: "focus:border-b focus:outline-none text-center bg-white",
                error: _
              }
            ),
            /* @__PURE__ */ e.jsx(
              c,
              {
                heading: "Your Sex",
                variant: "radio",
                options: [
                  { value: "Male", label: "Male" },
                  { value: "Female", label: "Female" }
                ],
                value: d,
                onChange: (t) => U(t),
                placeholder: "Select...",
                className: "text-center bg-white text-green-dark"
              }
            ),
            /* @__PURE__ */ e.jsx(
              c,
              {
                heading: "Your Height",
                unit: A,
                variant: "number",
                value: v,
                onChange: (t) => W(t),
                className: "focus:border-b focus:outline-none text-center bg-white",
                error: S
              }
            ),
            /* @__PURE__ */ e.jsx(
              c,
              {
                heading: "Your Weight",
                unit: T,
                variant: "number",
                value: p,
                onChange: (t) => L(t),
                className: "focus:border-b focus:outline-none text-center bg-white",
                error: Y
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx(
            c,
            {
              heading: "How much exercise do you typically get per week?",
              variant: "dropdown",
              options: [
                {
                  value: "Sedentary",
                  label: "Sedentary: Little or no exercise"
                },
                {
                  value: "Mild",
                  label: "Mild: Exercise > 20 mins, 1-3 times/week"
                },
                {
                  value: "Moderate",
                  label: "Moderate: Exercise for 30-60 mins, 3-4 times/week"
                },
                {
                  value: "Heavy",
                  label: "Heavy: Exercise for > 60 mins 5-7 times/week"
                },
                {
                  value: "Extreme",
                  label: "Extreme: Exceedingly active (twice daily)"
                }
              ],
              value: u,
              onChange: (t) => P(t),
              placeholder: "Select...",
              className: "text-center bg-white"
            }
          ),
          /* @__PURE__ */ e.jsx(
            c,
            {
              heading: "What are you hoping to achieve?",
              variant: "radio",
              options: [
                {
                  value: "Lose",
                  label: "Lose Weight"
                },
                {
                  value: "Maintain",
                  label: "Maintain Weight"
                }
              ],
              value: x,
              onChange: (t) => X(t),
              placeholder: "Select...",
              className: "text-center bg-white text-green-dark"
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: r(
              "justify-between items-center border rounded-2xl p-6 gap-4 text-grey-400",
              { "border-green": s, "border-blue": i }
            ),
            children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flex flex-row justify-between", children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col justify-between", children: [
                  /* @__PURE__ */ e.jsx(
                    "p",
                    {
                      className: r("text-left", {
                        "text-green-dark": s,
                        "text-black": i
                      }),
                      children: "Your recommended calorie intake"
                    }
                  ),
                  /* @__PURE__ */ e.jsxs("div", { className: "flex items-center space-x-1", children: [
                    /* @__PURE__ */ e.jsx(
                      "h3",
                      {
                        className: r("!font-body", {
                          "text-green-faint-dark": s,
                          "text-blue": i
                        }),
                        children: w || "0"
                      }
                    ),
                    /* @__PURE__ */ e.jsx(
                      "p",
                      {
                        className: r(
                          "font-demi text-left",
                          {
                            "text-green-faint-dark": s,
                            "text-blue": i
                          }
                        ),
                        children: "calories per day"
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ e.jsx(
                  le,
                  {
                    icon: ce,
                    size: "2x",
                    className: r({
                      "text-green-faint-light": s,
                      "text-blue": i
                    })
                  }
                )
              ] }),
              /* @__PURE__ */ e.jsxs("div", { className: "text-grey-400 bg-grey-100 grid grid-cols-2 rounded-2xl p-2 gap-2", children: [
                /* @__PURE__ */ e.jsx("div", { className: "text-left", children: "Your BMR" }),
                /* @__PURE__ */ e.jsx(
                  "div",
                  {
                    className: r("text-right", {
                      "text-green-dark": s,
                      "text-black": i
                    }),
                    children: E || "0"
                  }
                ),
                /* @__PURE__ */ e.jsx("div", { className: "text-left", children: "Protein" }),
                /* @__PURE__ */ e.jsxs(
                  "div",
                  {
                    className: r("text-right", {
                      "text-green-dark": s,
                      "text-black": i
                    }),
                    children: [
                      M || "0",
                      " g"
                    ]
                  }
                ),
                /* @__PURE__ */ e.jsx("div", { className: "text-left", children: "Carbohydrates" }),
                /* @__PURE__ */ e.jsxs(
                  "div",
                  {
                    className: r("text-right", {
                      "text-green-dark": s,
                      "text-black": i
                    }),
                    children: [
                      C || "0",
                      " g"
                    ]
                  }
                ),
                /* @__PURE__ */ e.jsx("div", { className: "text-left", children: "Fats" }),
                /* @__PURE__ */ e.jsxs(
                  "div",
                  {
                    className: r("text-right", {
                      "text-green-dark": s,
                      "text-black": i
                    }),
                    children: [
                      k || "0",
                      " g"
                    ]
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "text-grey-400 text-left", children: "Please always refer to your dietitian for more individualised information including meal plans and advice" }),
        /* @__PURE__ */ e.jsx(ie, { items: ae })
      ] })
    ] })
  ] });
};
export {
  we as default
};
